import { render, staticRenderFns } from "./RulesView.vue?vue&type=template&id=f1286ad6&scoped=true"
import script from "./RulesView.vue?vue&type=script&lang=js"
export * from "./RulesView.vue?vue&type=script&lang=js"
import style0 from "./RulesView.vue?vue&type=style&index=0&id=f1286ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1286ad6",
  null
  
)

export default component.exports